export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/5ba84b7c5997e2a9223c26a23a6fa17e.svg";